// ============================================================================
// CANCUN100 — PDFReporte.jsx (APP 2/27 · Reporte de ventas en PDF, con la marca y sin emoji)
// data = { titulo, enc[], filas[][], totales[], kpis[[l, v]], derechas[], logo }
// ============================================================================
import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import './pdfFonts';
import { LOGO_BASE64 } from './logoBase64';

const MORADO = '#6A35D4', TINTA = '#1C1630', GRIS = '#625B7A', CLARO = '#8A83A0', LINEA = '#ECE9F3', SUAVE = '#F1EAFE';
const s = StyleSheet.create({
  page: { paddingTop: 30, paddingBottom: 34, paddingHorizontal: 30, fontFamily: 'DM Sans', color: TINTA, fontSize: 8.5 },
  top: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 },
  logo: { width: 140, height: 32, objectFit: 'contain' },
  tit: { fontSize: 13, fontWeight: 700, color: MORADO, marginBottom: 2 },
  sub: { fontSize: 8.5, color: GRIS },
  kpis: { flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginBottom: 10 },
  kpi: { backgroundColor: SUAVE, borderRadius: 6, paddingVertical: 5, paddingHorizontal: 8, minWidth: 110 },
  kl: { fontSize: 7, color: GRIS, letterSpacing: 0.6, textTransform: 'uppercase' }, kv: { fontSize: 11, fontWeight: 700, color: TINTA },
  th: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: LINEA, paddingVertical: 4 },
  thc: { fontSize: 6.8, color: CLARO, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', paddingHorizontal: 3 },
  tr: { flexDirection: 'row', paddingVertical: 3.5, borderBottomWidth: 0.5, borderBottomColor: LINEA },
  td: { fontSize: 8, paddingHorizontal: 3 }, r: { textAlign: 'right' },
  tf: { flexDirection: 'row', paddingVertical: 5, borderTopWidth: 1.5, borderTopColor: LINEA },
  tfc: { fontSize: 8, fontWeight: 700, paddingHorizontal: 3 },
  pie: { position: 'absolute', bottom: 14, left: 30, right: 30, fontSize: 7, color: CLARO, textAlign: 'center' },
});
const PDFReporte = ({ data }) => {
  const d = data || {}; const n = (d.enc || []).length || 1; const w = `${100 / n}%`;
  return (
    <Document>
      <Page size="LETTER" orientation={n > 9 ? 'landscape' : 'portrait'} style={s.page}>
        <View style={s.top}>
          <View style={{ maxWidth: '70%' }}><Text style={s.tit}>{d.titulo}</Text><Text style={s.sub}>Cancun100 · Control Folios · Reportes · generado {new Date().toLocaleString('es-MX')}</Text></View>
          <Image src={d.logo || LOGO_BASE64} style={s.logo} />
        </View>
        <View style={s.kpis}>{(d.kpis || []).map(([l, v], i) => <View key={i} style={s.kpi}><Text style={s.kl}>{l}</Text><Text style={s.kv}>{v}</Text></View>)}</View>
        <View style={s.th} fixed>{(d.enc || []).map((h, i) => <Text key={i} style={[s.thc, { width: w }, d.derechas && d.derechas[i] ? s.r : null]}>{h}</Text>)}</View>
        {(d.filas || []).map((f, i) => <View key={i} style={s.tr} wrap={false}>{f.map((c, j) => <Text key={j} style={[s.td, { width: w }, d.derechas && d.derechas[j] ? s.r : null]}>{c}</Text>)}</View>)}
        <View style={s.tf}>{(d.totales || []).map((c, j) => <Text key={j} style={[s.tfc, { width: w }, d.derechas && d.derechas[j] ? s.r : null]}>{c}</Text>)}</View>
        <Text style={s.pie} fixed render={({ pageNumber, totalPages }) => `Reporte de ventas · página ${pageNumber} de ${totalPages} · documento interno`} />
      </Page>
    </Document>
  );
};
export default PDFReporte;
